(function() {
  let collection_handle = document.getElementById("collection-handle").innerHTML
  let cookie_name = "is-subscribed-klaviyo-" + collection_handle;
  if(localGetCookie(cookie_name)) {
    return;
  }
  else {
    window.history.pushState({}, '', window.location.href);
    sessionStorage.setItem('referrer-collection-handle', collection_handle);
    window.location.href = document.getElementById("gated-sale-page").innerHTML;
  }
})();

function localSetCookie(name, value, days) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function localGetCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}